import { defineMessages } from 'react-intl';

export default defineMessages({
    BuildingTitle: {
        id: 'quoteandbind.wizard.Commercial.Policy.Building',
        defaultMessage: 'Building'
    },
    NotApplicable: {
        id: 'quoteandbind.wizard.Commercial.Policy.NotApplicable',
        defaultMessage: 'N/A'
    },
    roofUpdate: {
        "id": "quoteandbind.wizard.Commercial.Roofing Update",
        "defaultMessage": "Roofing Update"
    },
    repairsAdditions: {
        "id": "quoteandbind.wizard.Commercial.Repairs/Additions",
        "defaultMessage": "Repairs/Additions"
    },
    buildersRisk: {
        "id": "quoteandbind.wizard.Commercial.buildersRisk",
        "defaultMessage": "Builders Risk Location"
    }
})